// extracted by mini-css-extract-plugin
module.exports = {"reviewsLink":"_ff667cc9"};